import * as React from 'react';
import { FC, useState, useEffect } from 'react';

//import { useFormState } from 'react-final-form';
import { useWatch } from 'react-hook-form';
import {
    useDataProvider,
    Loading,
    SelectArrayInput,
    useRecordContext,
    FunctionField,
} from 'react-admin';
import { useQuery } from '@tanstack/react-query';

import lodash from 'lodash';

interface Props {
    source: string;
    resource?: string;
    optionValue?: string;
    optionText?: string;
    allowEmpty?: boolean;
    url: string;
    qparamkey?: string;
    qparamval?: string;
    fullWidth?: boolean;
    label?: string;
    showAsText?: boolean;
    showIfControl?: string;
    showIfValue?: any;
}

interface ResItem {
    item_id: any;
    item_title: any;
}

const CustomSelectArrayInput: FC<Props> = ({
    source,
    label,
    resource = '',
    optionValue = 'item_id',
    optionText = 'item_title',
    allowEmpty = true,
    url,
    qparamkey,
    qparamval = '',
    fullWidth = true,
    showAsText = false,
    showIfControl = '',
    showIfValue = '',
    ...props
}) => {
    const showCheck = useWatch({ name: showIfControl });
    const showInput =
        showIfControl === ''
            ? true
            : showCheck !== undefined && showCheck === showIfValue
              ? true
              : false;
    /* const { values } = useFormState();
    const params =
        lodash.get(values, qparamval) != undefined
            ? qparamkey + '=' + lodash.get(values, qparamval)
             : '';*/

    const val = useWatch({ name: qparamval });
    const params = val != undefined ? qparamkey + '=' + val : '';
    const dataProvider = useDataProvider();
    // const [loading, setLoading] = useState(true);
    // const [customChoices, setCustomChoices] = useState<ResItem[]>();

    // useEffect(() => {
    //     dataProvider
    //         .getAny(url, params)
    //         .then(({ data }) => {
    //             setCustomChoices(data);
    //             setLoading(false);
    //         })
    //         .catch(error => {
    //             console.log(error);
    //             setLoading(false);
    //         });
    // }, [params]);

    // if (loading) return <Loading />;

    const { data, error, isPending, refetch } = useQuery({
        queryKey: [url, 'getAny', params],
        queryFn: () => dataProvider.getAny(url, params),
    });

    if (!data) return null;

    const customChoices = data.data;

    if (!customChoices) return null;

    if (showAsText) {
        return (
            <FunctionField
                render={record => {
                    const value = source
                        .split('.')
                        .reduce((acc, part) => acc && acc[part], record);
                    if (!value || !Array.isArray(value) || value.length === 0)
                        return '';
                    return value
                        .map(
                            v =>
                                customChoices.find(
                                    (cc: ResItem) =>
                                        cc[optionValue]?.toString() ===
                                        v?.toString()
                                )?.[optionText] || v
                        )
                        .join(', ');
                }}
            />
        );
    }

    if (!showInput) return null;

    return (
        <SelectArrayInput
            source={source}
            resource={resource}
            optionValue={optionValue}
            optionText={optionText}
            choices={customChoices}
            label={label}
            //allowEmpty={allowEmpty} tää pitää selvittää
            fullWidth={fullWidth}
            //options={{resettable: true}}
            //options={{ defaultOpen: true }}
            {...props}
        />
    );
};

export default CustomSelectArrayInput;
